<template>
    <div class="project-detail-view" v-if="project">
        <Breadcrumb />
        <div class="detail-header">
            <span class="title-watermark">PROJECT DETAIL</span>
            <h1 class="page-title">{{ project.projectName }}</h1>
            <div class="desc">项目详情与介绍</div>
        </div>
        <img v-if="project.coverImage" :src="fullImageUrl(project.coverImage)" alt="项目图片" class="project-image" />
        <div class="project-description-card">
            <div class="project-description" v-html="fixRichTextImg(project.content)"></div>
        </div>
    </div>
</template>

<script>
import Breadcrumb from '../components/Breadcrumb.vue';
import { getProjectDetail } from '../api/project';
import { fullImageUrl, fixRichTextImg } from '../utils/request';
import { applyPageSeo } from '../utils/seo';

export default {
    name: 'ProjectDetailView',
    components: { Breadcrumb },
    data() {
        return {
            project: null
        };
    },
    watch: {
        '$route.params.id': {
            immediate: true,
            handler() {
                this.fetchDetail();
            }
        }
    },
    methods: {
        fetchDetail() {
            const id = this.$route.params.id;
            getProjectDetail(id).then(res => {
                if (res && res.data && res.data.code === 200) {
                    this.project = res.data.data;
                    this.applyProjectSeo();
                }
            }).catch(err => {
                console.error('[ProjectDetail] fetchDetail error for id=' + id, err && (err.message || err));
            });
        },
        applyProjectSeo() {
            // Apply per-project SEO without global override
            const title = (this.project && this.project.projectName) ? `${this.project.projectName}` : undefined;
            applyPageSeo({
                title,
                keywords: this.project && this.project.keywords,
                description: this.project && this.project.description
            });
            // main.js 里 getSeoConfig 返回后会直接调 applyGlobalSeo, 会把项目 title 覆盖回 siteName
            // 用延迟再 apply 一次, 抢在 puppeteer 抓 HTML 之前, 确保 prerender 出来的 HTML 带项目名
            clearTimeout(this._seoTimer)
            this._seoTimer = setTimeout(() => this.applyProjectSeo(), 5000)
        },
        fullImageUrl,
        fixRichTextImg
    }
};
</script>

<style scoped>
.project-detail-view {
    padding: 32px;
    max-width: 1100px;
    margin: 0 auto;
}

.detail-header {
    position: relative;
    text-align: center;
    margin-bottom: 38px;
    margin-top: 8px;
}

.title-watermark {
    position: absolute;
    left: 50%;
    top: -18px;
    transform: translateX(-50%);
    font-size: 2.2rem;
    font-weight: 900;
    color: #1a2a47;
    opacity: 0.09;
    letter-spacing: 0.18em;
    user-select: none;
    pointer-events: none;
    z-index: 1;
    white-space: nowrap;
}

.page-title {
    position: relative;
    z-index: 2;
    text-align: center;
    font-size: 2rem;
    font-weight: 700;
    color: #1a2a47;
    margin-bottom: 12px;
    letter-spacing: 1px;
    margin-top: 0;
}

.desc {
    position: relative;
    z-index: 2;
    color: #555;
    font-size: 1.08rem;
    margin-bottom: 0;
    margin-top: 0;
    font-weight: 500;
    letter-spacing: 0.5px;
}

.project-image {
    width: 100%;
    max-width: 900px;
    margin: 32px auto 24px auto;
    display: block;
    border-radius: 12px;
    box-shadow: 0 4px 24px rgba(30, 60, 120, 0.10);
}

.project-description-card {
    background: #fff;
    border-radius: 18px;
    box-shadow: 0 4px 24px rgba(30, 60, 120, 0.06);
    padding: 36px 28px 32px 28px;
    margin-bottom: 32px;
}

.project-description {
    margin-top: 0;
    line-height: 1.9;
    font-size: 1.08rem;
    color: #222;
    word-break: break-word;
}

.project-description img {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
    margin: 18px 0;
    display: block;
}

.project-description table {
    width: 100% !important;
    border-collapse: collapse;
    margin: 18px 0;
}

.project-description th,
.project-description td {
    border: 1px solid #eee;
    padding: 8px 12px;
}

@media (max-width: 900px) {
    .project-detail-view {
        padding: 8px;
    }

    .project-description-card {
        padding: 14px 6px 14px 6px;
        border-radius: 10px;
    }

    .page-title {
        font-size: 1.1rem;
    }

    .desc {
        font-size: 0.98rem;
    }

    .title-watermark {
        font-size: 1.1rem;
        top: -8px;
    }
}
</style>